<template>

  <a-modal
    title="修改头像"
    :visible="visible"
    :maskClosable="false"
    :confirm-loading="submitLoading"
    :width="800"
    :footer="null"
    :destroyOnClose="true"
    @cancel="cancelHandel">
    <a-row>
      <a-col :xs="24" :md="12" :style="{height: '350px'}">
        <vue-cropper
          v-if="visible"
          ref="cropper"
          :img="options.img"
          :info="true"
          :outputType="options.outputType"
          :autoCrop="options.autoCrop"
          :autoCropWidth="options.autoCropWidth"
          :autoCropHeight="options.autoCropHeight"
          :fixedBox="options.fixedBox"
          @realTime="realTime"
        >
        </vue-cropper>
      </a-col>
      <a-col :xs="24" :md="12" :style="{height: '350px'}">
        <div class="avatar-upload-preview">
          <img :src="previews.url" :style="previews.img"/>
        </div>
      </a-col>
    </a-row>
    <br>
    <a-row>
      <a-col :lg="2" :md="2">
        <a-upload name="file" :beforeUpload="beforeUpload" :showUploadList="false">
          <a-button icon="upload">选择图片</a-button>
        </a-upload>
      </a-col>
      <a-col :lg="{span: 1, offset: 2}" :md="2">
        <a-button icon="plus" @click="changeScale(1)"/>
      </a-col>
      <a-col :lg="{span: 1, offset: 1}" :md="2">
        <a-button icon="minus" @click="changeScale(-1)"/>
      </a-col>
      <a-col :lg="{span: 1, offset: 1}" :md="2">
        <a-button icon="undo" @click="rotateLeft"/>
      </a-col>
      <a-col :lg="{span: 1, offset: 1}" :md="2">
        <a-button icon="redo" @click="rotateRight"/>
      </a-col>
      <a-col :lg="{span: 2, offset: 6}" :md="2">
        <a-button type="primary" :loading="uploading" @click="finish('blob')">保存</a-button>
      </a-col>
    </a-row>
  </a-modal>

</template>
<script>
import store from '@/store'
import { updateUserAvatar } from '@/api/system/user'
import { uploadObject, uploadOss } from '@/api/tool/oss'
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      visible: false,
      id: null,
      submitLoading: false,
      fileList: [],
      uploading: false,
      fileName: 'avatar.jpg',
      options: {
        // img: 'https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png',
        img: '',
        outputType: 'jpeg',
        autoCrop: true,
        autoCropWidth: 200,
        autoCropHeight: 200,
        fixedBox: true
      },
      previews: {}
    }
  },
  computed: {
    ...mapGetters(['avatar'])
  },
  methods: {
    edit (id) {
      this.id = id
      this.options.img = this.avatar || ''
      this.visible = true
      /* 弹窗展开后再刷新裁剪器, 否则容器宽度为 0 会导致画布空白(灰色) */
      this.refreshCropper()
    },
    refreshCropper (delay) {
      this.$nextTick(() => {
        setTimeout(() => {
          if (this.$refs.cropper) {
            this.$refs.cropper.refresh()
          }
        }, delay || 300)
      })
    },
    close () {
      this.id = null
      this.visible = false
      this.previews = {}
    },
    cancelHandel () {
      this.close()
    },
    changeScale (num) {
      num = num || 1
      this.$refs.cropper.changeScale(num)
    },
    rotateLeft () {
      this.$refs.cropper.rotateLeft()
    },
    rotateRight () {
      this.$refs.cropper.rotateRight()
    },
    beforeUpload (file) {
      const reader = new FileReader()
      // 把Array Buffer转化为blob 如果是base64不需要
      // 转化为base64
      reader.readAsDataURL(file)
      reader.onload = () => {
        this.options.img = reader.result
        // 图片变更后重新加载裁剪画布, 避免仍是灰色空白
        this.refreshCropper(50)
      }
      // 转化为blob
      // reader.readAsArrayBuffer(file)

      return false
    },

    // 上传图片（点击上传按钮）
    finish (type) {
      const _this = this
      if (!this.options.img) {
        this.$message.warning('请先选择图片')
        return
      }
      if (type !== 'blob') {
        return
      }
      // 输出裁剪后的图片
      this.$refs.cropper.getCropBlob((data) => {
        // 与通用上传组件保持一致: 前端直传OSS, 得到可访问的完整地址
        // blob 转 file, 保证上传时带上文件名和 contentType, 否则图片可能无法直接预览
        const uploadFile = new File([data], this.fileName, { type: 'image/' + (this.options.outputType || 'jpeg') })
        const filePath = uploadOss(this.fileName, 'avatar')
        uploadObject(filePath, uploadFile).then(imgUrl => {
          if (!imgUrl) {
            _this.uploading = false
            _this.$message.error('上传失败, 请稍后重试')
            return
          }
          // 回写头像地址
          updateUserAvatar({ avatar: imgUrl }).then(response => {
            const resultUrl = (response && response.data && response.data.imgUrl) || imgUrl
            //avatar
            store.commit('SET_AVATAR', resultUrl)
            _this.$message.success('上传成功')
            _this.$emit('ok', resultUrl)
            _this.close()
          }).catch(() => {
            _this.$message.error('保存头像失败, 请稍后重试')
          }).finally(() => {
            _this.uploading = false
          })
        }).catch(() => {
          _this.uploading = false
          _this.$message.error('上传失败, 请稍后重试')
        })
      })
    },
    okHandel () {
      const vm = this

      vm.submitLoading = true
      setTimeout(() => {
        vm.submitLoading = false
        vm.close()
        vm.$message.success('上传头像成功')
      }, 2000)
    },

    realTime (data) {
      this.previews = data
    }
  }
}
</script>

<style lang="less" scoped>

  .avatar-upload-preview {
    position: absolute;
    top: 50%;
    transform: translate(50%, -50%);
    width: 180px;
    height: 180px;
    border-radius: 50%;
    box-shadow: 0 0 4px #ccc;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>
